<template>
	<div class="popup-view">
		<slot />
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
	.popup-view {
		background-color: white;
		border-radius: 0;
		-webkit-box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.15);
		-moz-box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.15);
		box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.15);
	}
</style>